export class ManageAuditProgramListSearch {
  templateId: string;
  templateName: string;
  auditFirmName: string;
  auditFirmId: string;
  isActive: string;
  departmentIds: string;
  statusId: string;
  auditProgramId: string;
  auditProgramName: string;
  financialYearId: string;
  quarterId: string;
  regionId: string;
  companyId: string;
  siteIds: string;
  actionType: string;
  isWorkflowRequired: string;
  cdAuditStatus: string;
  wfPending: string;
  pendingApproved: string;
  pendingRejected: string;
  pendingReturned: string;

  isTriggered: string;
  freeSearchText: string;
  stakeholder: string;

  subMenu: string;
  function: string;
  auditProgramScopeId: string;
  wfType: string;
  order: string;
  reqDescription: string;

  auditPeriodFromDate: string;
  auditPeriodToDate: string;
  coveragePeriodFromDate: string;
  coveragePeriodToDate: string;
  reportReleaseDate: string;

  startIndex: number;
  endIndex: number;
  isAuditStatusChecked: boolean = true;
  tabName: string = '';
  auditFirmActionType: string;
  callingType: string;
  callingFrom: string;
  projectCode: string;
  pCalanderDate: any;
}
